var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:_vm.wrapperName,staticClass:"z-chart-wrapper w-full print:break-inside-avoid"})
}
var staticRenderFns = []

export { render, staticRenderFns }